import { BASE_URL } from "@/assets/constants/constants";
import { Icon } from "@/components/icons/Icon";

type ErrorScreenProps = {
  title?: string;
  description?: string;
};

export default function ErrorScreen({
  title = "Ha ocurrido un error",
  description = "No se ha podido cargar la página correctamente.",
}: ErrorScreenProps) {
  const handleReload = () => {
    window.location.href = BASE_URL;
  };

  return (
    <div
      data-testid="error-screen"
      className="flex min-h-fulldpx items-center justify-center bg-slate-50 px-6"
    >
      <div className="w-full max-w-md rounded-2xl border border-slate-200 bg-white p-8 shadow-lg">
        <div className="mb-6 flex justify-center">
          <div className="flex h-14 w-14 items-center justify-center rounded-full bg-red-100">
            <Icon name="warningTriangle" className="size-6 text-ib-red-dark" />
          </div>
        </div>

        <div className="text-center">
          <h1 className="text-2xl font-bold text-slate-900">{title}</h1>

          <p className="mt-3 text-sm leading-6 text-slate-600">{description}</p>

          <button
            type="button"
            onClick={handleReload}
            className="mt-6 inline-flex items-center justify-center rounded-xl bg-ib-red-dark px-5 py-3 text-sm font-semibold text-white transition hover:bg-ib-red-dark/70"
          >
            Volver a cargar
          </button>
        </div>
      </div>
    </div>
  );
}
